import { render } from "./ContactsCompanies.vue?vue&type=template&id=2a8db060"
import script from "./ContactsCompanies.vue?vue&type=script&lang=js"
export * from "./ContactsCompanies.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__